import { useContext } from 'react';
import { ContextProps, GlobalContext } from 'context/global-context';
import { Artist } from 'data/types';
import Image from 'next/image';
import SocialIcons from 'components/core/social-icons';
import styled from 'styled-components';

type ArtistDescriptionProps = Artist;

export const ArtistDescription: React.FC<ArtistDescriptionProps> = ({
  image,
  description,
  name,
  socials,
}) => {
  const { dictionary } = useContext<ContextProps>(GlobalContext);
  if (!description) {
    return null;
  }
  return (
    <StyledArtistDescription className="artist-box">
      {image && (
        <div className="image">
          <Image src={image.src} alt={name} sizes="150px" layout="fill" />
        </div>
      )}
      <div className="info">
        <h3>{dictionary.aboutArtistHeader}</h3>
        <div className="description">{description}</div>
        <SocialIcons override={socials} />
      </div>
    </StyledArtistDescription>
  );
};

const StyledArtistDescription = styled.aside`
  display: flex;
  align-items: flex-start;
  display: none;
  .image {
    width: 150px;
    height: 150px;
    margin-right: 1rem;
    position: relative;
  }
`;

export default ArtistDescription;
